import type NonEmptyText from '../non-empty-text';
import type { IStakeholder } from './stakeholder';
import { assertIsInstanceOfNonEmptyText } from '../assertions';
import Stakeholder from './stakeholder';

interface ICustomer extends IStakeholder {
	readonly name: NonEmptyText;
}

export default class Customer extends Stakeholder implements ICustomer {
	public get name(): NonEmptyText {
		return this.#name;
	}

	#name: NonEmptyText;
	public constructor({ key, name, stakeholderType, store }: ICustomer) {
		super({ key, stakeholderType, store });
		assertIsInstanceOfNonEmptyText(name);
		this.#name = name;
	}
}
